export const defaultBookSectionLabels = Object.freeze({
  pages: 'Sayfa',
  reading: 'Okuma',
  words: 'Kelimeler',
  listening: 'Dinleme',
  video: 'Video',
  animation: 'Animasyon',
  questions: 'Sorular',
  test: 'Test',
  beforeLesson: 'Ders Öncesi',
  afterLesson: 'Ders Sonrası',
  teacherEvaluation: 'Öğretmen Değerlendirmesi',
});

export function resolveBookSectionLabels(labels) {
  return Object.fromEntries(Object.entries(defaultBookSectionLabels).map(([key, fallback]) => {
    const value = labels?.[key];
    return [key, typeof value === 'string' && value.trim() ? value.trim() : fallback];
  }));
}
